import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAddPhone from './modal/phonemodal.vue'
import { toast } from '@/shared/utils/UIHelper'
import AssociateCreate from '../../../associate/components/associateCreate.vue'
import threeCPlusService from '@/shared/services/voip/ThreeCPlusService'
import ThreeCVoipService from '@/shared/services/voip/ThreeCVoipService'
import Voip3CPlusRepository from '@/shared/http/repositories/voip/voip3cplus'

export default {
  name: 'CrmDetailsContacts',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    phones: {
      type: Array,
      default: null
    },
    cardActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showConversation: false,
      data: null,
      form: null,
      conversationAssociate: null,
      hasVoipAccess: false,
      isCalling: false,
      currentCallId: null,
      currentCallNumber: null
    }
  },
  components: {
    AssociateCreate,
    ModalAddPhone
  },
  async created () {
    this.checkVoipAccess()
  },
  methods: {
    async checkVoipAccess () {
      try {
        if (!threeCPlusService.isInitialized) {
          await threeCPlusService.init()
        }
        this.hasVoipAccess = threeCPlusService.shouldShowVoipIcon()
      } catch (error) {
        this.hasVoipAccess = false
      }
    },
    openShowMessages (conversationAssociate, telefone) {
      // Validar se os dados essenciais estão presentes
      if (!conversationAssociate || !conversationAssociate.pessoa) {
        console.error('DEBUG: Dados do associado não disponíveis')
        toast.error('Dados do associado não disponíveis')
        return
      }
      if (!conversationAssociate.pessoa.document) {
        console.error('DEBUG: CPF/CNPJ não encontrado no card')
        toast.error('CPF/CNPJ não encontrado para esta pessoa.')
        return
      }

      if (
        !conversationAssociate.pessoa.nome &&
        !conversationAssociate.pessoa.nomeAssociado
      ) {
        console.warn('DEBUG: Nome não encontrado no card')
      }

      this.$refs.newConversationModal.openModal(conversationAssociate, telefone)
    },
    onLoad () {},
    onAddPhone () {
      this.$refs.ModalAddPhone.showModal()
    },
    closeShowMessages () {
      this.$refs.newConversationModal.closeModal()
    },
    onReload () {
      this.$emit('Reload')
    },
    async callPhone (telefone) {
      if (this.isCalling) {
        toast.warning('Uma chamada já está em andamento, reinicie a página')
        return
      }

      if (!this.hasVoipAccess) {
        toast.error('Acesso ao VoIP não disponível')
        return
      }

      try {
        this.isCalling = true
        if (!ThreeCVoipService.initialized) {
          await ThreeCVoipService.initialize()
        }

        const campaigns = await Voip3CPlusRepository.getCampaigns()

        if (!campaigns || campaigns.length === 0) {
          throw new Error('Nenhuma campanha/fila disponível')
        }

        const selectedCampaign = campaigns[0]

        await Voip3CPlusRepository.connectVoip({
          campaignId: selectedCampaign.id
        })

        await Voip3CPlusRepository.enterManualMode()

        const response = await Voip3CPlusRepository.makeCall({
          phoneNumber: telefone
        })

        this.currentCallId = response.call && response.call.id
        this.currentCallNumber = telefone

        this.$emit('call-started', {
          number: telefone,
          callId: this.currentCallId,
          campaign: selectedCampaign.name
        })
      } catch (error) {
        try {
          await Voip3CPlusRepository.disconnectVoip()
        } catch (disconnectError) {
          console.error('Erro ao desconectar:', disconnectError)
        }

        this.isCalling = false
        this.currentCallId = null
        this.currentCallNumber = null
      }
    },
    async stopCall () {
      if (!this.isCalling) {
        toast.warning('Nenhuma chamada ativa para desligar')
        return
      }

      try {
        await Voip3CPlusRepository.disconnectVoip()

        this.currentCallId = null
        this.currentCallNumber = null
        this.isCalling = false

        this.$emit('call-ended', {
          callId: this.currentCallId
        })
      } catch (error) {
        this.currentCallId = null
        this.currentCallNumber = null
        this.isCalling = false
      }
    },
    toastInfo () {
      toast.info('Esta funcionalidade ainda não está disponível no seu nxCoop.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/contacts/contact.js